// app/javascript/controllers/checkbox_validator_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "errorMessage"]

  connect() {
  }

  validate() {
    if (!this.checkboxTarget.checked) {
      this.checkboxTarget.classList.add('is-danger');
      this.errorMessageTarget.textContent = "Dieses Feld ist erforderlich"; // Text based on your preference
      return false;
    } else {
      this.checkboxTarget.classList.remove('is-danger');
      this.errorMessageTarget.textContent = ""; // Clear error message
      return true;
    }
  }

  change() {
    return this.validate();
  }
}
